import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import "./enquiry.css";
// import { Button } from "react-bootstrap"
// import IntlTelInput from "react-intl-tel-input"
import "react-intl-tel-input/dist/libphonenumber.js";
import "react-intl-tel-input/dist/main.css";
import swal from "sweetalert2";
import { validationForEmail } from "../../js/regex";
import axios from "axios";
// import qs from "qs"
import "animate.css/animate.min.css";
import Select from "react-select";
import Heading from "../Heading";
import ReactPixel from "react-facebook-pixel";
import ReCAPTCHA from "reaptcha";
// import { CountryDropdown, RegionDropdown } from "react-country-region-selector"

const handler = (status, value, countryData, number, id) => {
  // // console.log(status, value, countryData, number, id)
};
const options = [
  { value: "DG Gensets", label: "DG Gensets" },
  { value: "Electrical Punching", label: "Electrical Punching" },
  { value: "Portable Generators", label: "Portable Generators" },
];

export class BusinessEnquiry extends React.Component {
  constructor(args) {
    super(args);
    this.inputs = ["firstName", "lastName", "email", "msg", "number"];
    this.state = {
      isDisabled: true,
      active: false,
      selectedOption: null,
      Error: {},
      values: {},
      isVerify: false,
      country: " ",
      region: " ",
      isChange: true,
    };
  }
  componentDidMount() {
    ReactPixel.init("1700895836734320");
    ReactPixel.track("FindLocation", location);
  }
  handleChange = (selectedOption) => {
    this.setState({
      selectedOption,
      values: {
        ...this.state.values,
        product: selectedOption.value,
      },
    });
  };
  verifyCallback = () => {
    const { Error } = this.state;
    Error["isVerify"] = false;
    this.setState({
      isVerify: true,
      Error,
    });
  };
  selectCountry(val) {
    this.setState({
      values: {
        ...this.state.values,
        country: val,
      },
      isChange: false,
    });
    setTimeout(() => {
      this.setState({
        isChange: true,
      });
    }, 1000);
  }

  selectRegion(val) {
    this.setState({
      values: {
        ...this.state.values,
        region: val,
      },
      isChange: false,
    });
    setTimeout(() => {
      this.setState({
        isChange: true,
      });
    }, 1000);
  }
  handleChangeAndValidation = (key, e) => {
    let { Error } = this.state;
    this.setState({
      values: {
        ...this.state.values,
        [key]: e.target.value.trim(),
      },
    });
    delete Error[key];
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { values, isVerify } = this.state;
    let isFlag = false;
    let error = {};
    this.inputs.map((item, j) => {
      if (!values[item]) {
        isFlag = true;
        error[item] = true;
      } else if (item === "email") {
        error[item] = !validationForEmail(values[item]);
        isFlag = isFlag === true ? true : error[item];
      }
    });
    isFlag = isFlag ? true : !isVerify;
    error["isVerify"] = !isVerify;
    // ?console.log("values", values, error);

    //comment line 126 in prod
    // isFlag = false;

    if (isFlag) {
      this.setState({
        Error: error,
      });
    } else {
      const { firstName, lastName, email, number, product, msg } = values;

      const data = {
        first_name: firstName,
        last_name: lastName,
        email,
        number: "+" + number,
        product_of_interest: product,
        message: msg,
      };

      swal({
        title: "Checking...",
        text: "Please wait",
        imageUrl:
          "https://www.iima.ac.in/image/image_gallery?uuid=0ee6265e-1cf2-403b-b559-16b5d3508bd6&groupId=64124&t=1460634550238",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      ReactPixel.track("SubmitApplication");
      axios
        .post("https://jayceepower.com/api/public/index.php/enquiry", data)
        .then((res) => {
          swal.close();
          console.log(res);
          swal({
            title: "Successfully Submitted",
            html: `<div style='text-align: center'>Your details have been recorded.</div>`,
            type: "success",
            confirmButtonColor: "#e8300a",
          });
        })
        .catch((e) => {
          console.log(e);
          swal({
            title: "Warning",
            html: `<div style='text-align: center'>Internal Server error</div>`,
            type: "error",
          });
        });
    }
  };
  render() {
    const { selectedOption, Error, isVerify } = this.state;
    return (
      <div className="enquiry__wrapper">
        <div className="enquiry_content">
          <div>
            <Heading title="Business Enquiries" />
          </div>
          <div className="sub_head">
            Please fill in the form below with details of your requirements, and
            our team will be in touch within 2 working days.{" "}
          </div>
          <div className="business_form">
            <form className="">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="f_name">
                      First Name<spam style={{ color: "#e8300a" }}>*</spam>
                    </div>
                    <input
                      type=""
                      onChange={(e) =>
                        this.handleChangeAndValidation("firstName", e)
                      }
                      name="firstName"
                      id="name"
                      className="form-control"
                      placeholder="Enter First Name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="f_name">
                      Last Name<spam style={{ color: "#e8300a" }}>*</spam>
                    </div>
                    <input
                      type=""
                      onChange={(e) =>
                        this.handleChangeAndValidation("lastName", e)
                      }
                      name="firstName"
                      id="name"
                      className="form-control"
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <div className="f_name">
                      Email<spam style={{ color: "#e8300a" }}>*</spam>
                    </div>
                    <input
                      type="email"
                      onChange={(e) =>
                        this.handleChangeAndValidation("email", e)
                      }
                      name="email"
                      id="email"
                      className="form-control"
                      placeholder="Enter Email ID"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="f_name">
                      Number<spam style={{ color: "#e8300a" }}>*</spam>
                    </div>
                    <PhoneInput
                      inputClass={"form-control"}
                      value={this.state.values.number}
                      country={"in"}
                      buttonClass={"btn btn-primary"}
                      containerStyle={{ width: "80%", margin: "auto" }}
                      dropdownClass={"dropdown-menu"}
                      dropdownStyle={{ color: "darkgray", textAlign: "left" }}
                      placeholder={"+91 88888-88888"}
                      inputStyle={{
                        marginRight: "0px",
                        marginLeft: "39px",
                        width: "82%",
                        fontSize: "15px",
                      }}
                      onChange={(phone) => {
                        this.setState({
                          values: { ...this.state.values, number: phone },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="f_name">Product of Interest</div>
                    <Select
                      value={selectedOption}
                      onChange={this.handleChange}
                      style={{ height: "30px" }}
                      name="product"
                      // className="form-control"
                      options={options}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="msg">
                    <div className="f_name">
                      Message<spam style={{ color: "#e8300a" }}>*</spam>
                    </div>
                    <textarea
                      name="msg"
                      onChange={(e) => this.handleChangeAndValidation("msg", e)}
                      id="msg"
                      className="form-control"
                      placeholder="Please enter requirement details"
                      rows="5"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="recap">
                  <ReCAPTCHA
                    sitekey="6LdpSM0ZAAAAAP8_n6j1XV3dhG23Sslb-xxE9yO5"
                    onVerify={this.verifyCallback}
                  />
                  {Error.isVerify ? (
                    <div className="error-msg" style={{ color: "#a94442" }}>
                      Please verify that you are not robot
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="s_btn">
                  <button onClick={(e) => this.handleSubmit(e)}>Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

BusinessEnquiry.propTypes = {
  onHide: PropTypes.func,
};

export default BusinessEnquiry;



// WEBPACK FOOTER //
// ./src/components/BusinessEnquiry/index.js